export default __webpack_public_path__ + "static/media/William Jensen - Resume.5254713c.pdf";